export const Select = () => {
  return <div>Select</div>;
};

Select.defaultSize = { width: 10, height: 4 };

Select.properties = {};

Select.events = {
  change: {},
};
